import { render, staticRenderFns } from "./LiveNotice.vue?vue&type=template&id=6ae2dea4&scoped=true&"
import script from "./LiveNotice.vue?vue&type=script&lang=js&"
export * from "./LiveNotice.vue?vue&type=script&lang=js&"
import style0 from "./LiveNotice.vue?vue&type=style&index=0&id=6ae2dea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2dea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae2dea4')) {
      api.createRecord('6ae2dea4', component.options)
    } else {
      api.reload('6ae2dea4', component.options)
    }
    module.hot.accept("./LiveNotice.vue?vue&type=template&id=6ae2dea4&scoped=true&", function () {
      api.rerender('6ae2dea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/LiveNotice.vue"
export default component.exports